__turbopack_context__.v({
  "container": "ShippingInfoBox-module-scss-module__LwFdGG__container",
  "icon": "ShippingInfoBox-module-scss-module__LwFdGG__icon",
  "text": "ShippingInfoBox-module-scss-module__LwFdGG__text",
});
